import { render, staticRenderFns } from "./notifications_filter.vue?vue&type=template&id=2e5f823c&scoped=true&"
import script from "./notifications_filter.vue?vue&type=script&lang=js&"
export * from "./notifications_filter.vue?vue&type=script&lang=js&"
import style0 from "./notifications_filter.vue?vue&type=style&index=0&id=2e5f823c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f823c",
  null
  
)

export default component.exports